export const load = () => ({
	h1: 'Tips for Insulating and Soundproofing your Home ',
	title: 'Tips for Insulating and Soundproofing your Home',
	description:
		'Find tips and Tricks for insulating and soundproofing your home with window inserts. Learn how Indow window inserts can make your home more comfortable and energy efficient.',
	showTitle: true,
});
